<template>
    <header id="header" class="header">
        <div data-aos="fade-left" data-aos-duration="2000" data-aos-delay="50" class="header__slider" pause-on-hover="false">
            <div class="header__slider--slide">
                <img src="images/slider/Pufina-Distractie-in-Familie-header-1.png" alt="Pufina - Distractie in familie">
            </div>
            <div class="header__slider--slide">
                <img src="images/slider/Pufina-Distractie-in-Familie-header-2.png" alt="Pufina - Distractie in familie">
            </div>
            <div class="header__slider--slide">
                <img src="images/slider/Pufina-Distractie-in-Familie-header-3.png" alt="Pufina - Distractie in familie">
            </div>
        </div>
        
        <div class="header__teaser">
            <h1 data-aos="fade-up" data-aos-duration="2000" data-aos-delay="100" class="header__title">Distracție in familie</h1>
            <h2 data-aos="fade-up" data-aos-duration="2000" data-aos-delay="150" class="header__subtitle">Campania s-a încheiat!</h2>
            <p data-aos="fade-up" data-aos-duration="2000" data-aos-delay="200">Îți mulțumim pentru participare și îți pregătim noi surprize</p>
            <a data-aos="fade-up" data-aos-duration="2000" data-aos-delay="300" class="cta--blue" href="#" style="pointer-events: none;">Campanie încheiată</a>
        </div>
        <div data-aos="fade-down" data-aos-duration="3000" data-aos-delay="400" class="header__shapes">
            <img class="header__shapes--1" src="images/bg/header-left-shape.png">
        </div>
    </header>
</template>

<script>
    export default {
        data() {
            return {
                title: 'BIG TITLE',
                subtitle: 'Tease text',
                teaser: 'teaser small caps paragraph'
            }
            
        }
    }
</script>